import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType} from '../../constants';
import {
  GaTrackingSearchEventPayload
} from '~shared/modules/ga-tracking/models/business-models/ga-tracking-search-event-payload.model';

export class GATrackingSearchEvent implements GATrackingEvent {

  constructor(private searchEventPayload: GaTrackingSearchEventPayload) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.Search;
  }

  getPayload(): GATrackingEventPayload {
    const { term } = this.searchEventPayload;

    return {
      event: GaTrackingEventName.Search,
      category: GaTrackingEventCategory.SearchTerm,
      label: term ? term.toLowerCase() : '',
      gtmCustom: this.searchEventPayload
    };
  }
}
